import React, { useEffect, useState } from 'react';
import {Redirect } from "react-router-dom";
import { useCoverLetter } from '../../context/CoverLetterContext';
import { 
  COVERLETTER_JOBDETAILS,
  COVERLETTER_EXPERIENCE, 
  COVERLETTER_SKILLS,
  COVERLETTER_STRENGTH,
} from '../../constants/constants';
import '../../assets/scss/app/cover-letter-screens/on-bording-screens.scss';


const Customize = (props) => {
    const [back, setBack] = useState(false);
    const [next, setNext] = useState(false);
    const [redirect2, setRedirect2] = useState(null);
    const { 
      ques_ans_response,
      qa_steps_initiated,
    handlers: {
        save,
        saveQA,
        loadQA
    },
  } = useCoverLetter();

  const saveForm = (data) => {
    if(data.job_details_provided == false){
      //Required cleanup
      data.desired_company = ''
      data.desired_position = ''
      data.skills = []
    }
    saveQA({ ques_ans_response: {...ques_ans_response, ...data} })
  }
  useEffect(() => {
        //browser issue, page not opening at top
        window.scrollTo(0, 0)
    loadQA()
  }, []);

  useEffect(() => {
    (next || back) && history.pushState(null, COVERLETTER_JOBDETAILS);
    if(next && ques_ans_response.job_details_provided == true)
      setRedirect2(COVERLETTER_JOBDETAILS)
    else if(next && ques_ans_response.job_details_provided == false)
      setRedirect2(COVERLETTER_STRENGTH)
  }, [back, next])

  if (redirect2) return <Redirect to={redirect2} />
  return (
    <div className="cover-screen-outer small-screen-outer">
      <div className="screen-inner">
        <div className="block">
            <div className="progress-bar">
              <div className="bar-outer">
                  <div className="bar-inner"></div>
              </div>
              <div className="bar-levels">
                  <div className="level-text"><span className="level-mark"></span>Select a Template</div>
                  <div className="level-text active"><span className="level-mark"></span>Job Goals</div>
                  <div className="level-text"><span className="level-mark"></span>Work Info</div>
                  <div className="level-text"><span className="level-mark"></span>Finalize</div>
              </div>
            </div>
          <div className="screen screen-one">
            <h1>Are you applying for a specific job?</h1>
            <p>We'll customize your cover letter with the job title and employer if you specify a job. If you don't specify a job, we'll create a cover letter you can customize later.</p>
            <div className="screen-block">
              <div 
                className={`choose-job-title purple-btn${ques_ans_response.job_details_provided === true ? ' active' : ''}`}
                data-option="Yes"
                onClick={(e) => {
                  // toggleActiveButton(e.target.getAttribute('data-option'))
                  saveForm({ job_details_provided: true })
                }}>Yes</div>
              <div 
                className={`choose-job-title purple-btn${ques_ans_response.job_details_provided === false ? ' active' : ''}`}
                data-option="Not Yet"
                onClick={(e) => {
                  // toggleActiveButton(e.target.getAttribute('data-option'))
                  saveForm({ job_details_provided: false, disired_position: '', disired_company: '', skills:[] })
                }}>Not Yet</div>
            </div>
            <div className="screen-action">
            {/* <button className="round-btn" onClick={() => setBack(!back)}> <i className="arrow left-arrow-2"><ArrowRightIcon /></i><span>Back</span></button> */}
            <button className="round-btn  active" onClick={() => setNext(!next)}><span>Next</span><i className="arrow-bar-right"></i></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Customize;